export default "__VITE_ASSET__MMf7Iha3__"